// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#app-sub-root.ltp-payment-failed-root-section {
  background: #FAFAFA;
}

#header.header-page-ltp-payment-failed .logo-container {
  justify-content: center;
}

.page-ltp-payment-failed {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page-ltp-payment-failed .title {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10vh;
  margin-bottom: 32px;
}

.page-ltp-payment-failed .title svg path {
  height: 64px;
  width: 64px;
  stroke: #FF6464;
}

.page-ltp-payment-failed .title .text {
  color: #FF6464;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px; /* 128.571% */
  letter-spacing: 0.56px;
  margin: 24px auto 0;
  text-align: center;
}

.page-ltp-payment-failed .error-message {
color: #000;
font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: 24px;
letter-spacing: 0.32px;
  text-align: center;
}

.page-ltp-payment-failed .button-container {
  position: fixed;
  bottom: 45px;
  width: 327px;
  border-radius: 12px;
}

`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/ltp-payment-failed.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;AACA,WAAW;AACX,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB;AACjB,sBAAsB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["#app-sub-root.ltp-payment-failed-root-section {\n  background: #FAFAFA;\n}\n\n#header.header-page-ltp-payment-failed .logo-container {\n  justify-content: center;\n}\n\n.page-ltp-payment-failed {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.page-ltp-payment-failed .title {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 10vh;\n  margin-bottom: 32px;\n}\n\n.page-ltp-payment-failed .title svg path {\n  height: 64px;\n  width: 64px;\n  stroke: #FF6464;\n}\n\n.page-ltp-payment-failed .title .text {\n  color: #FF6464;\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 36px; /* 128.571% */\n  letter-spacing: 0.56px;\n  margin: 24px auto 0;\n  text-align: center;\n}\n\n.page-ltp-payment-failed .error-message {\ncolor: #000;\nfont-size: 16px;\nfont-style: normal;\nfont-weight: 500;\nline-height: 24px;\nletter-spacing: 0.32px;\n  text-align: center;\n}\n\n.page-ltp-payment-failed .button-container {\n  position: fixed;\n  bottom: 45px;\n  width: 327px;\n  border-radius: 12px;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
